
import { useEffect } from 'react';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import BodyReportHeroSection from '../home/components/BodyReportHeroSection';
import BodyReportDetailSection from '../home/components/BodyReportDetailSection';
import ReservationSection from '../home/components/ReservationSection';

const BodyReportPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-16">
        <BodyReportHeroSection />
        <BodyReportDetailSection />
        <ReservationSection />
      </main>
      <Footer />
    </div>
  );
};

export default BodyReportPage;
